import { createCarouselSlice } from './createCarouselSlice'

/**
 * Redux slice for the "Recommended for you" recommendations carousel.
 * Ships dark in Phase 1 — the slice is fully wired in code but is not
 * activated by SCS config until a later phase.
 * State shape and reducers come from `createCarouselSlice`.
 * @internal
 */
export const recommendedForYouSlice = createCarouselSlice(
  'recommendedForYouSlice',
)

export const {
  setItems: setRecommendedForYouItems,
  setStatus: setRecommendedForYouStatus,
} = recommendedForYouSlice.actions

export default recommendedForYouSlice.reducer
